import { AuthorizationServiceConfiguration, FetchRequestor } from "@openid/appauth";
import { AUTHORITY } from '@pv/constants';

const fetchAuthConfig = async () => {
    const requestor = new FetchRequestor();
    const authConfig = await AuthorizationServiceConfiguration.fetchFromIssuer(AUTHORITY, requestor);
    return authConfig;
}

export default fetchAuthConfig;